import type React from "react";
import { ReactComponent as Svg } from "./assets/void-icon.svg";
import * as styles from "./Icon.module.scss";

type LegVoidProps = React.SVGProps<SVGSVGElement>;

export const LegVoid = ({ className, ...props }: LegVoidProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
